export default "__VITE_ASSET__0da306cf__"